import * as React from "react";

const SvgIconMinus = (props) => {
  return (
    <svg width={31} height={31} viewBox="0 0 8.202 8.202" {...props}>
      <g transform="translate(-5.16 -79.244)" stroke="#c1cacc">
        <rect
          x={5.424}
          y={79.506}
          width={7.673}
          height={7.673}
          rx={1.279}
          ry={1.279}
          fill="#fff"
          strokeLinecap="round"
          strokeWidth={0.512}
        />
        <path
          d="M10.583 66.145v5.292"
          strokeLinecap="round"
          strokeWidth={0.529}
          transform="matrix(0 1 -.90557 0 71.555 72.76)"
          fill="none"
        />
      </g>
    </svg>
  );
};

export default SvgIconMinus;
